/**
 * GiftCardsResultsBody — exactly one of: the failure, the spinner, the empty
 * state, the desktop table, or the phone/tablet card list (BON-223). Mirrors
 * `BookingListBody`'s tiering — table on desktop, cards (stacked or 2-col
 * grid) below it.
 */
import { GiftCardsCardList } from './GiftCardsCardList';
import { GiftCardsEmptyState } from './GiftCardsEmptyState';
import { GiftCardsErrorBanner } from './GiftCardsErrorBanner';
import { GiftCardsLoadingState } from './GiftCardsLoadingState';
import { GiftCardsTable } from './GiftCardsTable';
import type { GiftCardListRow } from './giftCardTypes';

export interface GiftCardsResultsBodyProps {
  rows: GiftCardListRow[];
  loading: boolean;
  error: string | null;
  search: string;
  filtered: boolean;
  isDesktop: boolean;
  isTablet: boolean;
}

export function GiftCardsResultsBody({
  rows,
  loading,
  error,
  search,
  filtered,
  isDesktop,
  isTablet,
}: GiftCardsResultsBodyProps) {
  if (error) return <GiftCardsErrorBanner message={error} />;
  if (loading) return <GiftCardsLoadingState label="Loading gift cards" />;
  if (rows.length === 0) return <GiftCardsEmptyState search={search} filtered={filtered} />;
  if (isDesktop) return <GiftCardsTable rows={rows} />;
  return <GiftCardsCardList rows={rows} isTablet={isTablet} />;
}
